// Store VUE_APP_VARIANT in a variable first to prevent webpack from
// constant-folding comparisons like `"ltba" === "performax"` → false
// at build time. The placeholder is replaced by sed at container startup.
const variant = process.env.VUE_APP_VARIANT || "ltba";

export const isPerformax = variant === "performax";
export default variant;
